// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const MeasurementUnitsPage = () => {
  return <MasterDataListPage type="units" />;
};

export default MeasurementUnitsPage;